const majorTag = 'm-mokao'
const settings = {
  //项目名称
  title: '在线模考系统',
  //辅导名称
  majorTag:majorTag,
  //生产环境二级路径
  publicPath: '/tiku/'+majorTag+'/',
  //生产环境构建文件目录
  outputDir: majorTag,
  //静态资源放置目录
  assetsDir: 'static',
  //aes密钥
  aesKey: '823s4125660ijf;*',
  //iv密钥
  ivKey: 'qyu148#4(1p_1^4;',
  //请求接口地址  (默认：'/simPaperGw/moniexam'； 需要qzCloud在接口加上'/qzCloud')
  // baseApi: ['/simPaperGw/moniexam', '/qzCloud'],
  baseApi: ['/qzFree'],
  //请求重试delay
  retryDelay: 5000
}

module.exports = settings
